import {
  build,
  buildWithShareParams,
  canIUse,
  getPageConfig,
  initSDK,
  initV2,
  is,
  PerfTrack,
  query,
  setLoginConfig,
  setOmegaAttrs,
  trackEvent,
  weixinReady,
  // eslint-disable-next-line prettier/prettier
  xenv
} from '@didi/webx-js'
import mpx from '@mpxjs/core'
import { getCommonData } from '../service'
import store from '../store'
import {
  formatPageConfig,
  getQuery,
  initLocation,
  initLogin,
  setShare,
  setShareForWebx,
  setTitle,
  // eslint-disable-next-line
  shareConfig
} from '../utils'

export default function (branch = 'passenger') {
  return {
    onShareAppMessage() {
      if (this.info.needShareConfig) {
        return this.miniShareInfo || Promise.reject()
      }
      const { title, webxPath, shareCardImage } =
        shareConfig[this.info.template]
      return {
        title: title,
        path: build(buildWithShareParams(webxPath), getQuery()),
        imageUrl: shareCardImage,
      }
    },
    data: {
      pageConfig: null,
      info: {},
      show: false,
      loading: true,
      hasError: false,
      miniShareInfo: null,
      // startInit: false,
    },
    computed: {
      ...store.mapGetters(['query', 'initData', 'productType']),
    },
    async onLoad() {
      // window.__INITIAL_STATE__ = {
      //   xpubData: {
      //     scenes: {
      //       layers: [{ props: { pageConfig: this.props.pageConfig.value() } }],
      //     },
      //   },
      // }
      if (__mpx_mode__ === 'web') {
        if (window.__INITIAL_STATE__) {
          this.pageConfig =
            window.__INITIAL_STATE__.xpubData.scenes.layers[0].props.pageConfig
        }
      }
      PerfTrack.jsReady()
      initSDK({ branch })
      store.commit('reset') // 防止第二次打开被缓存
      store.commit('setQuery', query())
      this.info = this.props.info.value()
      PerfTrack.init({
        dchn: this.query.dchn,
        prod_key: this.info.prodKey || 'ut-dunion',
      })
      this.setLoginConfig()
      setOmegaAttrs(this.info)
      this.showPage()
      initLogin({}, this.info)
      if (__mpx_mode__ !== 'web') {
        await this.locate()
      } else {
        this.locate()
      }
      await Promise.all([
        this.init(),
        this.getPageConfig().catch(e => {
          console.log(e)
        }),
      ])
      if (!this.pageConfig) {
        console.log('pageConfig兜底')
        this.pageConfig = this.props.pageConfig.value()
        this.hasError = true
        this.showPage()
      }
    },
    methods: {
      ...store.mapMutations(['setInitData']),
      async locate() {
        await initLocation(
          this.info.template !== 'cz' && this.info.template !== 'ny'
        ).catch(e => {
          console.log(e)
        })
      },
      async init() {
        PerfTrack.requestBegin()
        try {
          const args = getCommonData()
          args.cz_upgrade = 1 // 滴滴联盟车主改版，新老活动兼容标识，上线全量之后可以删除
          const hasLocate = !!(args.lng || args.lat || args.cityId) // 网约车签到后续调用应该和本次一致
          const res = await initV2({
            initOption: {
              needPageConfig: true,
              needShareConfig: !!this.info.needShareConfig,
              config: {
                need_project_content:
                  // eslint-disable-next-line @didi/fin-check/usage-mpx-mode
                  !(__mpx_mode__ === 'web' && window.__INITIAL_STATE__),
                args,
              },
            },
          })
          if (res.conf.strategy_data.errno !== 0) {
            mpx.showToast({
              icon: 'none',
              mask: true,
              title: res.conf.strategy_data.errmsg,
            })
          }
          this.setInitData(
            Object.assign({ hasLocate }, res.conf.strategy_data.data)
          )
          const pageConfig =
            res.conf.content_conf?.project_data?.scenes?.layers?.[0]?.props
              ?.pageConfig
          pageConfig && (this.pageConfig = pageConfig)
          if (this.info.needShareConfig) {
            this.miniShareInfo = setShareForWebx(res.shareConf, this.info)
          }
          setOmegaAttrs({
            xak: this.initData.activity_info?.x_act_key,
            xid: res.conf.xid,
          })
        } catch (e) {
          mpx.showToast({
            icon: 'none',
            title: '服务异常，请稍后再试',
            duration: 2000,
            mask: true,
          })
          console.error(e)
        }
        this.showPage()
        PerfTrack.responseReady()
      },
      async getPageConfig() {
        // 老活动的活动内容，并不在APS中
        if (__mpx_mode__ === 'web') {
          if (window.__INITIAL_STATE__) {
            return
          }
        }
        const resPageConfig = await getPageConfig({
          args: {
            dchn: this.query.dchn,
          },
        })
        if (!this.pageConfig) {
          this.pageConfig =
            resPageConfig.conf.ext.content_conf.project_data.scenes.layers[0].props.pageConfig
          trackEvent('tech_ut_dunion_fe', '', {
            name: '老活动活动内容',
          })
        }
        this.showPage()
      },
      setLoginConfig() {
        store.commit('setProductType', this.info.productType || 'didi')
        const loginConfig = {
          extra_info: {
            dchn: this.query.dchn,
            entrance_channel: this.query.entrance_channel,
            channel: this.query.channel,
          },
        }
        if (__mpx_mode__ === 'web') {
          if (
            xenv() === 'weixin' &&
            this.query.code &&
            window.sessionStorage.getItem('wxOauth') === this.query.state
          ) {
            loginConfig.useOauthCode = this.info.wxOauth
            loginConfig.unionidLogin = this.info.wxOauth
            loginConfig.oauthcode = this.query.code
          }
        }
        if (__mpx_mode__ === 'web') {
          if (this.info.wxOauth) {
            const appid = {
              kf: 130018, // 线下 121357
              didi: 121230,
            }
            loginConfig.appid = appid[this.productType || 'didi']
          } else if (xenv() === 'gaswxmp') {
            loginConfig.appid = 121061
          }
        }
        canIUse('setLoginConfig') && setLoginConfig(loginConfig)
        setOmegaAttrs(this.query)
      },
      showPage() {
        // eslint-disable-next-line @didi/fin-check/usage-mpx-mode
        const ssg = __mpx_mode__ === 'web' && window.__INITIAL_STATE__
        const show = this.pageConfig && Object.keys(this.initData).length
        if (!ssg && !show && !this.hasError) {
          return
        }
        formatPageConfig(this.pageConfig, this.info.template)
        this.show = true
        this.closeLoading()
        setTitle(this.pageConfig.index?.title)
        if (__mpx_mode__ === 'web') {
          is('weixin')
            ? weixinReady(
                () => {
                  setShare(this.info)
                },
                {
                  needConfig: true,
                }
              )
            : setShare(this.info)
        }
      },
      closeLoading() {
        if (__mpx_mode__ === 'web') {
          const loading = document.querySelector('#loading')
          loading && (loading.style.display = 'none')
          this.$nextTick(() => {
            PerfTrack.domReady({
              isKey: true,
            })
          })
        } else {
          this.$nextTick(() => {
            this.loading = false
            PerfTrack.domReady({
              isKey: true,
            })
          })
        }
      },
    },
  }
}
